module.exports = __webpack_public_path__ + "static/media/TR.3e3e45f7.png";